import { useState } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

/**
 * A value in monospace with a copy button — for a secret or URL the user must take away. `caption`
 * names it above the box; `help` says what to do with it, below.
 */
export const CopyableValue: React.FC<{ value: string; label?: string; caption?: string; help?: string }> = ({
  value,
  label,
  caption,
  help,
}) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box sx={{ mb: 1.5 }}>
      {caption && (
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          {caption}
        </Typography>
      )}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        p: 1,
        bgcolor: "action.hover",
        borderRadius: 1,
        fontFamily: "monospace",
        fontSize: "0.85rem",
        wordBreak: "break-all",
      }}
    >
      <Box sx={{ flex: 1 }}>{value}</Box>
      <Tooltip title={copied ? "Copied" : "Copy"}>
        <IconButton size="small" aria-label={label ?? "Copy"} onClick={() => void copy()}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
      {help && (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
          {help}
        </Typography>
      )}
    </Box>
  );
};
